
import Vue from 'vue';
import * as commonConst from '../common/constants';
import * as sshConst from './constants';
import * as sshApis from '../../services/apis/ssh';


export default {
    [sshConst.describeKeys](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, sshApis.apiDescribeKeys);
            ctx.dispatch(commonConst.unifiedAjax, params).then(data => {
                ctx.commit(sshConst.describeKeys, data);
                resolve();
            }).catch(e => {
                reject(e);
            })
        });
    },
    [sshConst.createKey](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, sshApis.apiCreateKey);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [sshConst.deleteKey](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, sshApis.apiDeleteKey);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [sshConst.importKey](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, sshApis.apiImportKey);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [sshConst.detachKey](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, sshApis.apiDetachKey);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [sshConst.attachKey](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, sshApis.apiAttachKey);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    // 校验秘钥是否为2048位加密
    [sshConst.CheckKeyEncryption](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, sshApis.CheckKeyEncryption);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
    [sshConst.DetachInstanceKey](ctx, params) {
        return new Promise((resolve, reject) => {
            params = _.merge(params, sshApis.DetachInstanceKey);
            ctx.dispatch(commonConst.unifiedAjax, params).then((data) => {
                resolve(data);
            }).catch(e => {
                reject(e);
            })
        });
    },
};

